import { Box, Checkbox, FormControlLabel } from '@mui/material'
import { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import DropDownOA from '../../../common/dropDownOA'
import { Item } from '../../../common/snippets'
import { SplitButton } from '../../../common/SplitButton'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../../common/svg/refresh'
import { ReportHeading } from './../../Reports/common/ReportHeading'
import * as id from '../../Reports/reportId'
import * as lb from '../../Reports/reportLables'
import * as URL from '../../Reports/oldReportsUrls'
import moment from 'moment/moment'
import { appendToUrl, diffInMonths, focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import Datepicker from '../../../common/datePicker'
import { updateAlertError, updateModal } from '../../../../store/common/common_action'
import { getOwnChildBranches, getQuikViewTableData, mpesaTransactionReportData } from '../../../../store/reports/reports_action'
import ManageColumns from '../../../common/ManageColumnsUI'
import * as mdt from '../../../common/modaltypes'
import { GetRequest } from '../../../common/api'
import { urls } from '../../../common/constants'
import MpesaTransactionReportTable from './MpesaTransactionReportTable'
import { selectOptions } from './constants'

const MpesaTransactionReport = (props) => {
  const {
    data: { common, reports },
    updateAlertError,
    getQuikViewTableData,
    updateModal,
  } = props
 const dispatch = useDispatch()
  const { loginData, roleRights, showModal, modalType } = common
  const { mpesaTransactionReportTableData } = reports
  const reportName = 'Mpesa Transaction'
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [disableExcel, setDisableExcel] = useState(false)
  const [showTable, setShowTable] = useState(false)
  const [cityId, setCityId] = useState(false)
  const [selSourceBranch, setSelSourceBranch] = useState()
  const [selTransactionType, setSelTransactionType] = useState(selectOptions?.[0])
  const [sourceBranchList, setSourceBranchList] = useState([])
  const [tableData, setTableData] = useState([]);
  const [tableDataTwo, setTableDataTwo] = useState([]);

  const [selectedOption, setSelectedOption] = useState(selectOptions?.[0])
  const headerData = {
    toDate: moment(toDate).format('DD-MMM-YYYY'),
    fromDate: moment(fromDate).format('DD-MMM-YYYY'),
    selSourceBranch: selSourceBranch?.BranchName,
    selTransactionType:selTransactionType?.name
  }
   
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const branchData = {
        intUserID: loginData?.intUserID,
        intCompanyID: loginData?.intCompanyID,
        intIsActive: 1,
      }
      getOwnChildBranches(branchData, true, 24 * 60 * 60 * 1000)
      setSelSourceBranch({ BranchName: loginData?.strBranchName, BranchID: loginData?.intBranchID })
    }
    const obj = {
      CompanyID: loginData?.intCompanyID,
      CityID: loginData?.intCityID,
      UserID: loginData?.intUserID,
      BranchID: loginData?.intBranchID,
      Mode: 1,
    }
    GetRequest(urls.getReportBranchList, obj).then((res) => {
      if (res.status == 'Success') {
        setSourceBranchList(res?.Data?.Table)
      }
    })
  }, [loginData])



  useEffect(() => {
    focusElemnt(id.fromDate)
  }, [])

  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setCityId(
        !(
          loginData.IsBranchAdminUser ||
          loginData.IsMTPLAdminUser ||
          loginData.IsAdmin ||
          roleRights?.Table1?.[0]?.AllowViewAllBranchReport
        )
      )
      setDisableExcel(!roleRights?.Table1?.[0]?.AllowExportExcel)
    }
  }, [roleRights, loginData])

    useEffect(() => {
      if (mpesaTransactionReportTableData?.table1?.length > 0) {
        const updateData = mpesaTransactionReportTableData.table1.map((item, index) => ({
          ...item,
          isDataRow: true,
          TransactionID:item.Response ? JSON.parse(item.Response).TransID : '',

          srno: index + 1
        }));
        const updateDataTwo = mpesaTransactionReportTableData?.table?.map((item, index) => ({
          ...item,
          isDataRow: true,
          srno: index + 1
        })) || [];
    
        setTableData(updateData);
        setTableDataTwo(updateDataTwo);
      } else {
        setTableData([]);
        setTableDataTwo([]);
      }
    }, [mpesaTransactionReportTableData]);
    
  const handleClick1 = () => {
    setShowTable(true)
    if (moment(toDate).endOf('day').valueOf() - moment(fromDate).startOf('day').valueOf() > (31 * 24 * 60 * 60 * 1000)) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
        setShowTable(true)
        const obj = {
          CompanyID: loginData?.intCompanyID,
          // BranchID: loginData?.intBranchID,
          BranchID: 0,
          FromDate: moment(fromDate).format("YYYY-MM-DD"),
          ToDate: moment(toDate).format("YYYY-MM-DD"),
        }
        dispatch(mpesaTransactionReportData(obj))
      }
  }

  const handleClick2 = () => {
    let url = URL.MpesaTransactionReport
    const urlData = URL.MpesaTransactionReportParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.dtFromDate = fromDate.format('DD-MMM-YYYY')
    urlData.dtToDate = toDate.format('DD-MMM-YYYY')
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const reset = () => {
    setFromDate(moment(new Date()))
    setToDate(moment(new Date()))
    setSelSourceBranch(sourceBranchList?.[0])
    setSelectedOption(selectOptions?.[0])
    setShowTable(false)
  }

  return (
    <Item sx={{ padding: '0' }} className="reports">
      <ReportHeading reportName={reportName} />
      <Box sx={sx.reportFlex}>
        <Item sx={sx.itemsx} style={{ width: '350px' }} className="input--container bookingDatePicker">
          <Datepicker
            name={'From Date'}
            label={'From Date'}
            id={id.fromDate}
            value={fromDate}
            dateChange={(date) => {
              setFromDate(date)
              setShowTable(false)
              focusElemnt(id.toDate)
            }}
            width="100%"
          />
        </Item>
        <Item sx={sx.itemsx} style={{ width: '350px' }} className="input--container bookingDatePicker">
          <Datepicker
            label={'To Date'}
            id={id.toDate}
            value={toDate}
            dateChange={(date) => {
              setToDate(date)
              setShowTable(false)
              focusElemnt('SelectBranch')
            }}
            width="100%"
          />
        </Item>
        <Item sx={sx.itemsx} style={{ width: '290px' }}>
          <DropDownOA
            id={'SelectBranch'}
            label={'Select Branch'}
            data={sourceBranchList || []}
            defaultvalue={selSourceBranch?.BranchName}
            idKey={`BranchID`}
            dataKey={`BranchName`}
            onSelect={(val) => {
              setSelSourceBranch(val)
              setShowTable(false)
            }}
            searchPlaceholder={`Search Branch`}
            width="310px"
            nextId={'TransactionType'}
            prevId={'to_date_id'}
          />
        </Item>
        <Item sx={sx.itemsx} style={{ width: '290px' }}>
          <DropDownOA
            id={'TransactionType'}
            label={'Transaction Type'}
            data={selectOptions || []}
            defaultvalue={selectedOption?.name || selectedOption}
            idKey={`id`}
            dataKey={`name`}
            onSelect={(val) => {
              setSelTransactionType(val)
              setShowTable(false)
            }}
            searchPlaceholder={`Transaction Type`}
            width="310px"
            nextId={'SplitButton'}
            prevId={'SelectBranch'}
          />
        </Item>
        <Item
          sx={sx.itemsx}
          onKeyDown={(e) =>
            navigation3(e, showTable ? (disableExcel ? 'ExportToPdf' : 'ExportToExl') : id.fromDate, 'TransactionType', () =>
              handleClick1()
            )
          }
        >
          <SplitButton
            options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
            // hideToggle={true}
            onClick1={handleClick1}
            onClick2={handleClick2}
            id1={'SplitButton'}
          />
        </Item>
        <Item sx={{ ...sx.itemsx }} style={{ cursor: 'pointer' }} onClick={() => reset()}>
          <RefreshSvg width={'24px'} height={'24px'} />
        </Item>
      </Box>
      {showTable && (
        <MpesaTransactionReportTable
          headerData={headerData}
          loginData={loginData}
          toDate={toDate}
          fromDate={fromDate}
          selSourceBranch={selSourceBranch}
          selTransactionType={selTransactionType}
          showTable={showTable}
          setShowTable={setShowTable}
          tableData={tableData}
          tableDataTwo={tableDataTwo}
        />
      )}
    </Item>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateAlertError, getQuikViewTableData, updateModal }
export default connect(mapStateToProps, mapDispatchToProps)(MpesaTransactionReport)
